import "./Services.scss";
import ServiceLink from "../../components/ServiceLink/ServiceLink";

export default function Services() {
  return (
    <div className="services">
     <ServiceLink title="Logo Design" to="/services/logo-design" />
     <ServiceLink title="Ad Design" to="/services/ad-design" />
     <ServiceLink title="Digital Design" to="/services/ad-design" />
     <ServiceLink title="Marketing Collateral" to="/services/marketing-collateral" />
 
    </div>
  );
}